// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__34ADy","title":"AfterBackImages_title__Z8lqI","images":"AfterBackImages_images__oie-7"};